import { clerkPlugin } from "@clerk/vue";
import { createPinia } from "pinia";
import { createApp } from "vue";
import App from "./App.vue";
import { captureError, initAnalytics } from "./analytics";
import { env } from "./env";
import router from "./router";
import "./style.css";
import "./index.css";

const isE2E = Boolean(import.meta.env.VITE_E2E);
const app = createApp(App);
const pinia = createPinia();

app.use(pinia);
app.use(router);

if (!isE2E) {
  if (!env.clerkPublishableKey) {
    throw new Error("Add your Clerk Publishable Key to the .env file");
  }
  app.use(clerkPlugin, { publishableKey: env.clerkPublishableKey });
}

// Initialize PostHog analytics (only in production with valid API key)
if (env.posthog.enabled) {
  initAnalytics();
}

// Configure global error handler
app.config.errorHandler = (err, instance, info) => {
  console.error("[Vue Error]", err, info);

  // Capture error in PostHog with context (only if analytics enabled)
  if (err instanceof Error && env.posthog.enabled) {
    captureError(err, {
      vue_component: instance?.$options.name || "Unknown",
      vue_info: info,
      vue_lifecycle_hook: info,
    });
  }
};

// Capture unhandled promise rejections (only log in development)
window.addEventListener("unhandledrejection", (event) => {
  console.error("[Unhandled Rejection]", event.reason);

  if (env.posthog.enabled) {
    const error =
      event.reason instanceof Error
        ? event.reason
        : new Error(String(event.reason));

    captureError(error, {
      type: "unhandled_rejection",
      promise: event.promise,
    });
  }
});

app.mount("#app");
